module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DataTable', {
    attrs: {
      "value": _vm.leaveRequestList,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N",
      "field": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "sortable": true,
      "field": "employeeName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['employeeName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'employeeName', $$v)
            },
            expression: "filters['employeeName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date From",
      "sortable": true,
      "field": "fromDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['fromDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'fromDate', $$v)
            },
            expression: "filters['fromDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date To",
      "sortable": true,
      "field": "toDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['toDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'toDate', $$v)
            },
            expression: "filters['toDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Alternative Employee",
      "sortable": true,
      "field": "alternateEmployeeName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['alternateEmployeeName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'alternateEmployeeName', $$v)
            },
            expression: "filters['alternateEmployeeName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Leave Type",
      "sortable": true,
      "field": "absenceType",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['absenceType']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'absenceType', $$v)
            },
            expression: "filters['absenceType']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editLeaveRequest(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.cancelDelete,
      "deleted": _vm.deleteLeaveRequest
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de76f478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Leave/leaveReports.vue
// module id = 2416
// module chunks = 0